import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Breadcrumb, Descriptions, Modal, Popconfirm, Collapse, Typography, Select, Divider, InputNumber, Row, Tag, Col, Button, Table, Form, Input, theme, Spin, Layout, Space, } from "antd";
import axios from "axios";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js';
import Headerdiv from "../layout/header.js";
import Footerdiv from "../layout/footer.js";
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import { AlertError, AlertSuccess } from '../usableclasses.js';
import { Link } from 'react-router-dom';

const { Panel } = Collapse;
const { Content } = Layout;
const { Title, Text } = Typography;

const PurchaseOrderDetail = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

    const { id } = useParams();
    const navigate = useNavigate();
    const [poDetails, setPoDetails] = useState(null);
    const [products, setProducts] = useState([]);
    const [poItems, setPoItems] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [costPrice, setCostPrice] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [totalCost, setTotalCost] = useState(0);
    const [totalVat, setTotalVat] = useState(0);
    const [totalTax, setTotalTax] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [totallocalShipping, setTotalLocalShipping] = useState(0);
    const [totalintShipping, setTotalIntShipping] = useState(0);

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);

    const fileInputRef = useRef(null);

    const getPoDetailsById = () => {
        axios.get(`${ApiURL}/purchase/getpoheaderdetails/${id}`, {
            headers: { SystemAccessToken: TOKEN },
        }).then((res) => {

            setPoDetails(res.data);
            setTotalVat(res.data.totalVat || 0);
            setTotalTax(res.data.totalTax || 0);
            setTotalDiscount(res.data.totalDiscount || 0);
            setTotalIntShipping(res.data.totalShippingInt || 0);
            setTotalLocalShipping(res.data.totalShippingLocal || 0);
        });
    };


    const fetchPOItems = () => {
        axios
            .get(`${ApiURL}/purchase/getpoitemdetails/${id}`, {
                headers: { SystemAccessToken: TOKEN },
            })
            .then((res) => setPoItems(res.data));
    };
    const handleProductChange = async (value) => {
        setLoading(true);
        setSelectedProduct(value);

        try {
            // Find selected product details
            const product = products.find((item) => item.id === value);
            if (product) {
                setCostPrice(product.proCostPrice);
                setTotalCost(product.proCostPrice * quantity);
                form.setFieldsValue({
                    productCost: product.proCostPrice,
                    productTotal: product.proCostPrice * quantity,
                });
            }
        } catch (error) {
            AlertError("Error fetching product details");
        } finally {
            setLoading(false);
        }
    };

    const handleQuantityChange = (value) => {
        setQuantity(value);
        const newTotalCost = costPrice * value;
        setTotalCost(newTotalCost);
        form.setFieldsValue({ productTotal: newTotalCost });
    };

    const handleCostPriceChange = (value) => {
        setCostPrice(value);
        const newTotalCost = value * quantity;
        setTotalCost(newTotalCost);
        form.setFieldsValue({ productTotal: newTotalCost });
    };

    const handleAddItem = async (values) => {

        setLoading(true);
        try {
            const payload = {
                poId: id,
                productId: values.productId.toString(),
                productCost: values.productCost.toString(),
                productQty: values.productQty.toString(),
                productTotal: values.productTotal.toString(),
                createdBy: UPDATED_BY
            }

            const res = await axios.post(`${ApiURL}/purchase/additem`, payload, {
                headers: { SystemAccessToken: TOKEN }
            });


            AlertSuccess(res.data.message || "Item Added Successfully");
            fetchPOItems();
            getPoDetailsById();
            form.resetFields();
        } catch (error) {
            AlertError('Item addition failed');
        } finally {
            setLoading(false);
        }


    };

    const handleDeleteItem = (productId) => {
        
        axios
            .post(
                `${ApiURL}/purchase/deleteitem`,
                { poId: id, productId: productId, deletedBy: UPDATED_BY },
                { headers: { SystemAccessToken: TOKEN } }
            )
            .then(() => {
                AlertSuccess("Item deleted");
                fetchPOItems();
            });
    };

    const handleFileChange = (event) => {

        const file = event.target.files[0];
        if (file) {
            const allowedExtension = ['.jpg', '.png', '.pdf'];
            const selectedFileExtension = file.name.split('.').pop().toLowerCase();

            if (allowedExtension.includes('.' + selectedFileExtension)) {
                setSelectedFile(file);
            }
            else {
                setSelectedFile(null);
                AlertError("Invalid file extension. Please select a file with .jpg and .png extension.");
                fileInputRef.current.value = '';
            }
        }

    };

    const handleUpload = async () => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append('PoId', id);
            formData.append('UploadedBy', UPDATED_BY);
            formData.append('UploadFile', selectedFile);

            try {
                await axios.post(`${ApiURL}/purchase/uploadfiletopo`, formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            SystemAccessToken: TOKEN,
                        },
                    }
                );
                AlertSuccess("file uploaded successfully.");

                fileInputRef.current.value = '';

                getPoDetailsById();

            } catch (error) {

                AlertError("Failed to upload.");

            } finally {
                fileInputRef.current.value = '';
            }


        }
        else {
            AlertError("Please select a file before uploading.");
        }
    };

    const handleDownload = async (filename) => {
        if (filename) {

            try {
                const response = await axios.post(`${ApiURL}/purchase/downloadfileinpo`, { PoId: id, fileName: filename, downloadedBy: UPDATED_BY },
                    {
                        responseType: "blob", // Correct: Tells Axios to expect a Blob response
                        headers: {
                            SystemAccessToken: TOKEN,
                        },
                    }
                );

                // Create a Blob from the response data
                const pdfBlob = new Blob([response.data]);

                // Create a temporary URL for the Blob
                const url = window.URL.createObjectURL(pdfBlob);

                // Create a temporary <a> element to trigger the download
                const tempLink = document.createElement("a");
                tempLink.href = url;
                tempLink.setAttribute(
                    "download",
                    filename
                ); // Set the desired filename for the downloaded file

                // Append the <a> element to the body and click it to trigger the download
                document.body.appendChild(tempLink);
                tempLink.click();

                // Clean up the temporary elements and URL
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(url);

                AlertSuccess("file downloaded successfully.");


            } catch (error) {

                AlertError("Failed to download file.");

            } finally {

            }


        }
        else {
            AlertError("Please select a file before downloading.");
        }
    };

    const handleEditClick = () => {
        setIsModalOpen(true);
    };

    const handleUpdate = () => {
        setLoading(true);
        const validTotalVat = totalVat ?? 0;
        const validTotalTax = totalTax ?? 0;
        const validTotalDiscount = totalDiscount ?? 0;
        const validTotalLocalShipping = totallocalShipping ?? 0;
        const validTotalIntShipping = totalintShipping ?? 0;


        if (validTotalVat === "" || validTotalTax === "" || validTotalDiscount === "" || validTotalLocalShipping === "" || validTotalIntShipping === "") {
            AlertError("All fields are required!");
            setLoading(false);
            return;
        }
        const payload = {
            poId: id,
            totalVat: totalVat.toString(),
            totalTax: totalTax.toString(),
            totalDiscount: totalDiscount.toString(),
            totalShippingLocal: totallocalShipping.toString(),
            totalShippingInt: totalintShipping.toString(),
            updatedBy: UPDATED_BY
        };

        axios.post(`${ApiURL}/purchase/updatepoadditions`, payload, {
            headers: { SystemAccessToken: TOKEN }
        })
            .then((res) => {
                AlertSuccess(res.data.message || 'Updated Successfully');
                getPoDetailsById();
                setIsModalOpen(false);
            })
            .catch(() => AlertError("Update failed"))
            .finally(() => setLoading(false));
    };
    const handleCompletePurchaseOrder = async () => {
        setLoading(true);
        try {
            await axios.post(`${ApiURL}/purchase/pocomplete`, {
                poId: id,
                completedBy: UPDATED_BY,
            }, {
                headers: { SystemAccessToken: TOKEN }
            });

            AlertSuccess("Purchase order completed successfully!");
            navigate("/polist");
        } catch (error) {
            AlertError("Failed to complete the purchase order.");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {

        axios
            .get(`${ApiURL}/products/dropdown/all`, {
                headers: { SystemAccessToken: TOKEN },
            })
            .then((res) => {
                setProducts(res.data)
                getPoDetailsById()
                fetchPOItems();
            });

    }, [id]);

    const getStatusTag = (status) => {
        switch (status) {
            case "DRAFT":
                return <Tag color="blue">{status}</Tag>;
            case "PENDING":
                return <Tag color="yellow">{status}</Tag>;
            case "APPROVED":
                return <Tag color="green">{status}</Tag>;
            case "REJECTED":
                return <Tag color="red">{status}</Tag>;
            case 'DELETED':
                return <Tag color="red">{status}</Tag>;
            default:
                return <Tag>{status}</Tag>;
        }
    };

    if (!poDetails) return <p>Loading...</p>;


    return (

        <Spin spinning={loading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px' }}>

                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item><Link to="/polist">Purchase Orders</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Purchase Order - {poDetails.poReferance}</Breadcrumb.Item>
                    </Breadcrumb>

                    <div style={{ padding: 20, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
                        <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
                            <Collapse defaultActiveKey={["1"]}>
                                <Panel header={"PO : " + poDetails.poReferance} key="1">
                                    <Descriptions bordered column={{ md: 3, sm: 1 }}>
                                        <Descriptions.Item label="Vendor Name">{poDetails.vendorName}</Descriptions.Item>
                                        <Descriptions.Item label="Vendor Bill No">{poDetails.vendorBillNo}</Descriptions.Item>
                                        <Descriptions.Item label="Vendor Bill Date">{moment(poDetails.vendorBillDate).format("DD/MM/YYYY")}</Descriptions.Item>
                                        <Descriptions.Item label="Created By">{poDetails.createdBy}</Descriptions.Item>
                                        <Descriptions.Item label="Created Date">{poDetails.createdDate}</Descriptions.Item>
                                        <Descriptions.Item label="Current Status">
                                            {getStatusTag(poDetails.currentStage)}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="PO Note"><div dangerouslySetInnerHTML={{ __html: poDetails.poNote }} /></Descriptions.Item>
                                        <Descriptions.Item label="Attachment">
                                            {poDetails.poAttachmentFile == null ? (
                                                <p style={{ fontStyle: "italic" }}>No Attachments</p>
                                            ) : (
                                                <Button color="purple" variant="outlined"
                                                    style={{ marginTop: "8px", isplay: "flex", justifyContent: "flex-end" }}
                                                    onClick={() => handleDownload(poDetails.poAttachmentFile)}>
                                                    Download File
                                                </Button>
                                            )}
                                        </Descriptions.Item>
                                        <Descriptions.Item label="Uploaded File">
                                            <input style={{ margin: "2px", border: "1px", borderColor: "#565656" }} type="file" ref={fileInputRef} onChange={handleFileChange} />

                                            <Button type="primary"
                                                style={{ marginTop: "8px", isplay: "flex", justifyContent: "flex-end" }}
                                                onClick={() => handleUpload()}>
                                                Upload File
                                            </Button>
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Panel>
                            </Collapse>

                            {poDetails.currentStage === "DRAFT" && (
                                <>
                                    <h3>Add Items</h3>
                                    <Form form={form} layout="vertical" onFinish={handleAddItem}>
                                        <Row gutter={16}>
                                            <Col xs={24} md={5}>
                                                <Form.Item
                                                    label="Select Item"
                                                    name="productId"
                                                    rules={[{ required: true, message: "Please select a product" }]}
                                                >
                                                    <Select placeholder="Select Item" onChange={handleProductChange} loading={loading}>
                                                        {products.map((item) => (
                                                            <Select.Option key={item.id} value={item.id}>
                                                                {item.label}
                                                            </Select.Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                            </Col>
                                            <Col xs={24} md={5}>
                                                <Form.Item
                                                    label="Quantity"
                                                    name="productQty"
                                                    rules={[{ required: true, message: "Please enter quantity" }]}
                                                >
                                                    <InputNumber
                                                        style={{ width: "100%" }}
                                                        min={1}
                                                        onChange={handleQuantityChange}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={5}>
                                                <Form.Item
                                                    label="Cost Price"
                                                    name="productCost"
                                                    rules={[{ required: true, message: "Please enter cost price" }]}
                                                >
                                                    <InputNumber
                                                        style={{ width: "100%" }}
                                                        min={0}
                                                        precision={2}
                                                        onChange={handleCostPriceChange}
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={5}>
                                                <Form.Item label="Total Price" name="productTotal">
                                                    <InputNumber
                                                        style={{ width: "100%" }}
                                                        min={0}
                                                        precision={2}
                                                        disabled
                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} md={4}>
                                                <Button type="primary" htmlType="submit" style={{ marginTop: "32px", width: "100%" }}>
                                                    Add Item
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </>
                            )}

                            <h3>List Of Items In PO</h3>
                            <Table
                                dataSource={poItems}
                                columns={[
                                    { title: "Item Name", dataIndex: "itemName" },
                                    { title: "Quantity", dataIndex: "quantity" },
                                    { title: "Cost Price", dataIndex: "costPrice" },

                                    { title: "Total Cost", dataIndex: "totalCost" },

                                    ...(poDetails.currentStage === "DRAFT"
                                        ? [
                                            {
                                                title: "Action",
                                                key: "action",
                                                render: (_, record) => (
                                                    <Space size="middle">
                                                        <Popconfirm
                                                            title="Are you sure to delete this item?"
                                                            onConfirm={() => handleDeleteItem(record.itemId)}
                                                            okText="Yes"
                                                            cancelText="No"
                                                        >
                                                            <Button type="link" icon={<DeleteOutlined />} danger />
                                                        </Popconfirm>
                                                    </Space>
                                                ),
                                            },
                                        ]
                                        : []),
                                ]}
                                pagination={false}
                                scroll={{ y: 250 }}
                                summary={() => poItems.length > 0 && (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row style={{ backgroundColor: "#ebeff0", fontWeight: "bold" }}>
                                            <Table.Summary.Cell index={0}><b>Total</b></Table.Summary.Cell>
                                            <Table.Summary.Cell index={1}><b>{poDetails.totalQty}</b></Table.Summary.Cell>
                                            <Table.Summary.Cell index={2} />
                                            <Table.Summary.Cell index={3}><b>{poDetails.totalProductCost}</b></Table.Summary.Cell>
                                            {poDetails.currentStage === "DRAFT" && <Table.Summary.Cell index={4} />}
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                )}
                            />
                            <Divider style={{ borderColor: '#7ea8ed' }}></Divider>
                            <Row style={{ justifyContent: 'flex-end' }}>
                                <Col xs={24} md={8} style={{ padding: '5px', display: 'flex', flexDirection: 'column', width: '100%', }}>

                                    {[
                                        { label: "Total Vat ", value: poDetails.totalVat },
                                        { label: "Total Taxes ", value: poDetails.totalTax },
                                        { label: "Total Discount ", value: poDetails.totalDiscount },
                                        { label: "Total Locat Shipping ", value: poDetails.totalShippingLocal },
                                        { label: "Total Init. Shipping ", value: poDetails.totalShippingInt },
                                    ].map((item, index) => (
                                        <Row
                                            key={index}
                                            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', padding: '5px 0' }}
                                        >
                                            <h3 style={{ margin: 0, flex: 1, textAlign: 'left' }}><b>{item.label}</b></h3>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>


                                                <Text strong style={{ fontSize: "16px", textAlign: 'right' }}>
                                                    RS {item.value}
                                                </Text>
                                                {poDetails.currentStage === "DRAFT" && (
                                                    <EditOutlined
                                                        style={{
                                                            fontSize: "18px",
                                                            color: "#1890ff",
                                                            cursor: "pointer",
                                                            padding: "4px",
                                                            borderRadius: "4px",

                                                        }}
                                                        onClick={handleEditClick}


                                                    />
                                                )}
                                                {/* <Input prefix="RS " value={item.value} disabled style={{ width: 150, color: 'black', fontWeight: 'bold', textAlign: 'right' }} /> */}

                                            </div>
                                        </Row>
                                    ))}
                                    <Divider style={{ borderColor: '#7ea8ed' }}></Divider>
                                    <Row
                                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '20px 0' }}
                                    >
                                        <h2 style={{ margin: 0, flex: 1, textAlign: 'left' }}>Final Amount</h2>

                                        <Text strong style={{ fontSize: "18px", color: 'black', paddingRight: '30px' }}>
                                            RS {poDetails.totalCost}
                                        </Text>
                                        {/* <Input prefix="RS " value={poDetails.totalCost} disabled style={{ width: 150, fontWeight: 'bold', color: 'black' }} />
                                     */}
                                    </Row>
                                    <Divider style={{ borderColor: '#7ea8ed' }}></Divider>
                                </Col>
                            </Row>

                            {poDetails.currentStage === "DRAFT" && (
                                <Row style={{ padding: '5px', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                    <Button onClick={() => navigate("/polist")} style={{ backgroundColor: "gray", color: "white", marginRight: 10 }}>Save as Draft</Button>
                                    <Button type="primary" onClick={() => setIsConfirmModalVisible(true)}>
                                        Send to Approval
                                    </Button>
                                </Row>
                            )}


                        </Space>
                    </div>
                </Content>
                <Footerdiv />
                <Modal
                    title="Edit Additional Costs"
                    open={isModalOpen}
                    onCancel={() => setIsModalOpen(false)}
                    footer={[
                        <Button key="cancel" onClick={() => setIsModalOpen(false)}>Cancel</Button>,
                        <Button key="update" type="primary" onClick={handleUpdate}>Update</Button>
                    ]}
                >
                    <Form layout="vertical">
                        <Form.Item label="Total Vat" rules={[{ required: true, message: "total vat can't be empty" }]}>
                            <InputNumber
                                value={totalVat}
                                onChange={(value) => setTotalVat(value ?? 0)}
                                min={0} precision={2}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>
                        <Form.Item label="Total Taxes" rules={[{ required: true, message: "total taxes can't be empty" }]}>
                            <InputNumber
                                value={totalTax}
                                onChange={(value) => setTotalTax(value ?? 0)}
                                min={0} precision={2}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>
                        <Form.Item label="Total Discount" rules={[{ required: true, message: "total discount can't be empty" }]}>
                            <InputNumber
                                value={totalDiscount}
                                onChange={(value) => setTotalDiscount(value ?? 0)}
                                min={0} precision={2}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>
                        <Form.Item label="Total Local Shipping" rules={[{ required: true, message: "total local shipping can't be empty" }]}>
                            <InputNumber
                                value={totallocalShipping}
                                onChange={(value) => setTotalLocalShipping(value ?? 0)}
                                min={0} precision={2}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>
                        <Form.Item label="Total International Shipping" rules={[{ required: true, message: "total international shipping can't be empty" }]}>
                            <InputNumber
                                value={totalintShipping}
                                onChange={(value) => setTotalIntShipping(value ?? 0)}
                                min={0} precision={2}
                                style={{ width: "100%" }}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    title="Confirm Approval"
                    visible={isConfirmModalVisible}
                    onOk={handleCompletePurchaseOrder}
                    onCancel={() => setIsConfirmModalVisible(false)}
                    okText="Yes, Send"
                    cancelText="Cancel"
                >
                    <p>Are you sure you want to send this purchase order for approval?</p>
                </Modal>

            </Layout>
        </Spin>

    );
};

export default PurchaseOrderDetail;
